import React from "react";
import ChangeBadge from "./ChangeBadge";
import { Skeleton } from "./ui/Skeleton";

// Long numbers must never be cut off with "...": on a narrow phone cell the font shrinks with the length of the value,
// and if it still does not fit, the unit wraps under the number (the value itself never wraps or truncates).
function valueSizeClass(value) {
  const len = String(value ?? "").length;
  if (len >= 12) return "text-base";
  if (len >= 9) return "text-lg";
  return "text-xl";
}

/**
 * A single cell of the KPI strip (the strip and its divider lines are drawn by the parent). No box and no big icon:
 * label, large value with a quiet unit, and the change compared to the previous period.
 * invert: for metrics where growth means worse (e.g. expense).
 * pending: first load, shows a placeholder shape instead of zeros.
 */
export default function KpiCompareCard({ label, value, unit, changePct, icon: Icon, onClick, invert = false, pending = false, compareLabel = "prethodni period", compareLabelLong = "u odnosu na prethodni period" }) {
  const Tag = onClick ? "button" : "div";

  return (
    <Tag
      type={onClick ? "button" : undefined}
      onClick={onClick}
      className={`flex min-w-0 flex-col justify-start bg-surface px-4 py-3.5 text-left dark:bg-slate-900 ${
        onClick ? "w-full cursor-pointer transition-colors hover:bg-slate-50 dark:hover:bg-slate-800/60" : ""
      }`}
    >
      <div className="flex items-center gap-1.5 text-xs font-medium text-slate-500 dark:text-slate-400">
        {Icon && <Icon aria-hidden="true" className="shrink-0 text-sm" />}
        <span className="truncate">{label}</span>
      </div>

      {pending ? (
        <div className="mt-2 flex flex-col gap-2" role="status" aria-label="Učitavanje">
          <Skeleton className="h-6 w-28" />
          <Skeleton className="h-4 w-20" />
        </div>
      ) : (
        <>
          <div className="mt-1.5 flex flex-wrap items-baseline gap-x-1 gap-y-0">
            <span className={`whitespace-nowrap font-semibold tabular-nums tracking-tight text-slate-900 dark:text-slate-50 sm:text-2xl ${valueSizeClass(value)}`}>
              {value}
            </span>
            {unit && <span className="shrink-0 text-xs font-medium text-slate-500 dark:text-slate-400">{unit}</span>}
          </div>
          <div className="mt-1.5 flex flex-wrap items-center gap-x-1.5 gap-y-0.5 text-xs">
              <ChangeBadge changePct={changePct} invert={invert} />
              <span className="text-slate-500 dark:text-slate-400">
                <span className="hidden xl:inline">{compareLabelLong}</span>
                <span className="xl:hidden">{compareLabel}</span>
              </span>
          </div>
        </>
      )}
    </Tag>
  );
}
